import { gql } from "@apollo/client";

export const GET_TERRITORIES = gql`
query getAllTerritories{
    getAllTerritories{
        arcimedes_row_id
        market
        product_type
        territory
        zip
        city
        county
        agent
    }
}
`

export const GET_TERRITORY_AGENT_MAPING = gql`
query territoryAgentMappingData($agentId: Int!){
    territoryAgentMappingData(agentId: $agentId){
        success
        message
        data {
            master_id
            arcimedes_row_id
            market
            product_type
            territory
            agent_id
            deleted
        }
        error
    }
}
`

export const GET_TEAM = gql`
query getAllTeamMembers{
    getAllTeamMembers{
        arcimedes_row_id
        first_name
        last_name
        deleted
    }
}
`

export const DELETE_TERRITORY_AGENT_MAP = gql`
mutation DeleteTerritories($input: [TerritoryAgentMapingInput]) {
  deleteTerritories(input: $input) {
    success
  }
}`

export const CREATE_TERRITORY_AGENT_MAP = gql`
mutation CreateTerritories($input: [TerritoryAgentMapingInput]) {
  createTerritories(input: $input) {
    territories {
      territory_id
      arcimedes_row_id
      deleted
      agent_id
    }
  }
}
`

export const GET_TERRITORY_AGENTS = gql`
query territoryAgentMapping{
    territoryAgentMapping {
    data {
      arcimedes_row_id
      territory
      market
      product_type
      first_name
      last_name
      agent_id
    }
    success
  }
}
`